import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';
import datepicker from 'jquery-ui/ui/widgets/datepicker';
import datepickerDe from 'jquery-ui/ui/i18n/datepicker-de';
import datepickerFr from 'jquery-ui/ui/i18n/datepicker-fr-CH';
import datepickerIt from 'jquery-ui/ui/i18n/datepicker-it-CH';
import getDaysInMonth from "../utils/getDaysInMonth";

const lang = __('language');
datepicker.setDefaults(datepicker.regional[lang.replace('_', '-')]);

jQuery.widget('ep.birthday', {
	options: {
		minYears: 16
	},
	_create: function() {
		const date = new Date();
		const birthday = date.getDate()+ "." + (date.getMonth()+1) + "." + (date.getFullYear()-18);

		this.element.datepicker({
			maxDate: '+2y',
			changeYear: true,
			yearRange : '1920:'+(date.getFullYear()-this.options.minYears),
			defaultDate: birthday,
			changeMonth: true,
			onChangeMonthYear: function(year, month){
				const elm = jQuery(this);

				const currentDate = elm.datepicker('getDate');

				let day = currentDate === null ? 1 : currentDate.getDate();
				const daysInMonth = getDaysInMonth(year, month);
				if (day > daysInMonth) {
					day = daysInMonth;
				}

				const date = new Date(year, month -1, day, 12, 0, 0, 0);
				elm.datepicker('setDate', date);
			}
		});
	}
});

export default function(){
	
}